import type { Environment } from './env.model';

export const environment: Environment = {
  url: 'https://www.energymarketprice.com',
  apiUrl: 'https://www.energymarketprice.com/siteapi',
  production: false,
  sso: {
    clientId: 'emp-admin-dashboard',
    issuer: 'https://sso.energymarketprice.com/',
  },
};
